import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

@Component({
  selector: "ui-radio-input",
  styleUrls: ["./ui-styles.css"],
  template: `<mat-radio-group
      color="primary"
      aria-labelledby="example-radio-group-label"
      class="example-radio-group"
      [(ngModel)]="currentQuestion.answerText"
      *ngIf="currentQuestion?.dataTypeName == 'radio'"
      >
      <mat-radio-button
        class="example-radio-button"
        *ngFor="let option of currentQuestion.options"
        [value]="option.value"
        (change)="onRadioChanged($event)"
       >
       <span style="white-space: normal" bind-innerHTML="option.text | safeHtml"></span>

      </mat-radio-button> 
      <mat-form-field *ngIf="currentQuestion.answerText === 'Other - [UserText]'">
        <input
        type="text"
        matInput=""
        required=""
        name="{{ currentQuestion.questionFieldName }}-Other"
        placeholder="Please specify Other"
        [(ngModel)]="currentQuestion.otherText"
      />   
    </mat-form-field>
 </mat-radio-group>`,
})
export class RadioinputComponent implements OnInit {
  @Input() currentQuestion: any;
  @Output() onChangeEvent = new EventEmitter<any>();

  constructor() {
   
}

  ngOnInit() {
  }

  // onInputChanged(event: any) {
  //   this.currentQuestion.answerText = this.currentQuestion.answerText.replace(
  //     "[UserText]",
  //     event.target.value
  //   );
  //   console.log(event.target.value);
  // }

  onRadioChanged(event){
    this.onChangeEvent.emit(this.currentQuestion);
  }
}
